<template>
  <div class="ps-settings">
    <v-tabs center-active class="tabber" background-color="transparent">
      <v-tab link to="/manager">Benutzer</v-tab>
      <v-tab link to="/manager/product-settings">Produkte</v-tab>
      <v-tab link to="/manager/statistics">Statistik</v-tab>
      <v-tab link to="/manager/mockup-settings">Mockups</v-tab>
      <v-tab link to="/manager/generation-errors">Fehler</v-tab>
      <v-tab link to="/manager/mail-settings">Mails</v-tab>
      <v-tab link to="/manager/live-editor">Live Editor</v-tab>
      <v-tab link to="/manager/import">Import</v-tab>
    </v-tabs>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "AdminView",
};
</script>

<!-- Gemeinsames Design-System aller Settings-Tabs (ps-*), bewusst EINMAL
     unscoped hier eingebunden statt je Komponente -->
<style lang="scss">
@import "@/components/Settings/Products/product-settings.scss";
</style>

<style lang="scss" scoped>
.tabber {
  margin-bottom: 16px;

  ::v-deep .v-tab {
    text-transform: none;
    font-weight: 600;
    letter-spacing: 0.2px;
  }
}
</style>
